// extracted by mini-css-extract-plugin
export default {"sourceBlock":"SourseBlock_sourceBlock__Ilfma","wrapContent":"SourseBlock_wrapContent__qvTQr"};